import * as PropTypes from 'prop-types'
import { format } from 'date-fns'
import { useTranslation } from 'react-i18next'

import { getAssetLink } from '../../../../helpers/get-asset-link'
import Icon from '../../../Icons'
import { ZoomFrame } from '@/components/ui/zoomable-image'

const NotesModal = ({ handleCancel, notes, setShowAddNoteModal }) => {
  const { t } = useTranslation(['maintenance', 'common'])
  return (
    <div className="maintenance-request-notes">
      <div className="maintenance-request-notes__container">
        <div className="window-header">
          <div className="title">{t('maintenance:requestPreview.notes.title')}</div>
          <div className="navi-button" onClick={() => handleCancel()}>
            <Icon icon="cross" />
          </div>
        </div>
        <div className="main-view">
          <div className="notes-list">
            {notes.map((noteData) => (
              <div className="note-container" key={noteData.id}>
                <div className="note-header">
                  <span>{t('maintenance:requestPreview.notes.noteLabel')}</span>
                  <span>{format(noteData.updatedAt, 'MM/dd/yyyy hh:mm a')}</span>
                </div>
                <p>{noteData.note}</p>
                <div className="images-list-container">
                  {noteData.photos.length && noteData.photos.length > 0
                    ? noteData.photos.map((image, index, photos) => {
                        const src = getAssetLink({ path: 'chitown-building', file: image })
                        return (
                          <ZoomFrame
                            key={image}
                            className="image-frame"
                            hintSize="2rem"
                            src={src}
                            title={t('maintenance:requestPreview.notes.noteLabel')}
                            images={photos.map((file) =>
                              getAssetLink({ path: 'chitown-building', file }),
                            )}
                            initialIndex={index}
                          >
                            <img src={src} className="image" />
                          </ZoomFrame>
                        )
                      })
                    : null}
                </div>
                <span>
                  {t('maintenance:requestPreview.notes.author', { author: noteData.author })}
                </span>
              </div>
            ))}
          </div>
        </div>
        <div className="window-footer">
          <div className="footer-buttons">
            {/* <button type="submit" className={`button button-black is-block `} onClick={() => {}}>
              {'Remove'}
            </button> */}
            <button className={`button button-gray is-block  `} onClick={() => handleCancel()}>
              {t('common:actions.cancel')}
            </button>
            <button
              onClick={() => setShowAddNoteModal(true)}
              className={`button button-primary is-block `}
            >
              {t('maintenance:requestPreview.notes.add')}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

NotesModal.propTypes = {
  handleCancel: PropTypes.func,
  setShowAddNoteModal: PropTypes.func,
  notes: PropTypes.array,
}

export default NotesModal
